// Phones show the 1280x720 game at about half size (a 750 px wide landscape screen → k ≈ 0.47),
// so a menu drawn for the desktop has ~18 px buttons and ~6 px text there. On touch devices a
// menu's layer is scaled up about its panel's centre, as if the canvas were shown at
// TARGET_SCALE, never past the screen (margin), and slid back inside when it sits near an edge.
// Children stay in world coordinates; Phaser hit-tests through the container's transform.
export const TARGET_SCALE = 0.8;

export function enlargeTransform({ touch, k, box, view, margin = 12 }) {
  if (!touch || !(k > 0) || k >= TARGET_SCALE) return { scale: 1, x: 0, y: 0 };
  const fit = Math.min((view.W - 2 * margin) / box.w, (view.H - 2 * margin) / box.h);
  const scale = Math.max(1, Math.min(TARGET_SCALE / k, fit));
  if (scale === 1) return { scale: 1, x: 0, y: 0 };
  const halfW = (box.w * scale) / 2, halfH = (box.h * scale) / 2;
  const clamp = (v, lo, hi) => (lo > hi ? (lo + hi) / 2 : Math.min(hi, Math.max(lo, v)));
  const cx = clamp(box.x, view.ox + margin + halfW, view.ox + view.W - margin - halfW);
  const cy = clamp(box.y, view.oy + margin + halfH, view.oy + view.H - margin - halfH);
  return { scale, x: cx - box.x * scale, y: cy - box.y * scale };
}
